/**
 * Centralized time-of-day logic.
 *
 * Night is 12am–5am because nobody wants to be told
 * "Good morning" at 12:30am.
 */

export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

export function getTimeOfDay(hour: number): TimeOfDay {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour < 5) return 'night';
  return 'evening';
}
